// checklists.ts — Endpoints templates checklists + applications + mappings.
import { req } from './_internals.js';

export const checklistsApi = {
  getTemplates: () => req('GET', '/checklists/templates'),
  getTemplate: (id: number | string) => req('GET', '/checklists/templates/' + id),
  createTemplate: (d: unknown) => req('POST', '/checklists/templates', d),
  updateTemplate: (id: number | string, d: unknown) => req('PUT', '/checklists/templates/' + id, d),
  renameTemplate: (id: number | string, name: string) =>
    req('PATCH', '/checklists/templates/' + id + '/rename', { name }),
  deleteTemplate: (id: number | string) => req('DELETE', '/checklists/templates/' + id),
  applyTemplate: (pid: number | string, d: unknown) =>
    req('POST', '/checklists/projects/' + pid + '/apply', d),
  getApplications: (pid: number | string) =>
    req('GET', '/checklists/projects/' + pid + '/applications'),
  getApplication: (id: number | string) => req('GET', '/checklists/applications/' + id),
  setMappings: (id: number | string, d: unknown) =>
    req('PUT', '/checklists/applications/' + id + '/mappings', d),
  applyMappings: (id: number | string) =>
    req('POST', '/checklists/applications/' + id + '/apply-mappings'),
  createActionForInstance: (id: number | string) =>
    req('POST', '/checklists/instances/' + id + '/create-action'),
};
